




















import { ItemType } from '@/models/items/ItemEnums'
import Vue from 'vue';
import DvFilterPopover from '@/components/util/DvFilterPopover.vue';

interface IData {
    entries: IEntry[];
}

interface IEntry {
    id: ItemType;
    label: string;
    selected: boolean;
}

function friendlyName(s: string): string {
    const split = s.split('_').map((v) => v[0].toUpperCase() + v.substring(1).toLowerCase());
    return split.join(' ');
}

function generateEntries(): IEntry[] {
    const ret: IEntry[] = [];
    for (const key of Object.keys(ItemType)) {
        if (!isNaN(Number(key))) {
            ret.push({
                id: Number(key as any),
                label: friendlyName(ItemType[key as any]),
                selected: true,
            });
        }
    }
    
    return ret;
}

export default Vue.extend({
    components: {
        DvFilterPopover,
    },
    data(): IData {
        return {
            entries: generateEntries(),
        };
    },
    mounted() {
        this.syncQuery();
    },
    watch: {
        $route() {
            this.syncQuery();
        },
    },
    computed: {
        selectedCount(): number {
            const selected = this.entries.filter((v) => v.selected).length;
            return selected === this.entries.length ? 0 : selected;
        },
    },
    methods: {
        toggle(evt: InputEvent, entry: IEntry) {
            const target = evt.target as HTMLInputElement;
            const selected = target.checked;
            entry.selected = selected;
            this.compute();
        },
        //  skipCompute mirrors ItemSearchCategorySelector/PartSelector's
        //  selectNone(skipCompute). Without it, syncQuery's "clear
        //  everything, then re-mark the restored subset" two-step emits a
        //  spurious select([]) from the clearing step -- the parent page's
        //  sameIdSet echo-guard can't suppress it (filter.types still holds
        //  the real, non-empty selection at that instant), so it pushes
        //  types=[] to the URL, which re-triggers this selector's own
        //  $route watcher, which reconstructs the real selection and emits
        //  it again, which pushes the URL back -- forever. Verified live:
        //  loading a URL with a partial (non-empty, non-full) `t=` selection
        //  hung the page in an unbroken request ping-pong against duck
        //  before this fix (found while fixing the identical, freshly-
        //  introduced bug in ItemSearchRankSelector -- this selector was its
        //  template, so it carried the same gap; see task-7-report.md fix
        //  round 3).
        select(set: boolean, skipCompute = false) {
            this.entries.forEach((v) => v.selected = set);
            if (!skipCompute) {
                this.compute();
            }
        },
        compute() {
            const ret = this.entries.filter((v) => v.selected).map((v) => v.id);
            
            const res = ret.length === this.entries.length ? [] : ret;
            this.$emit('select', res);
        },
        syncQuery() {
            const q = this.$route.query;
            
            function extractNumericArray(v: any): number[] {
                if (v == null || v === '') {
                    return [];
                }
                
                return v.split(',').map(Number);
            }
            
            const rawTypes = extractNumericArray(q.t);
            if (rawTypes.length === 0) {
                this.select(true);
            } else {
                this.select(false, true);
                for (const e of this.entries) {
                    const idx = rawTypes.findIndex((v) => v === e.id);
                    if (idx !== -1) {
                        e.selected = true;
                    }
                }
                
                this.compute();
            }
        }
    }
})
